import { defineMessages } from 'react-intl';

export default defineMessages({
  userApartmentsListLabel: {
    defaultMessage: 'Apartment',
    description: 'User apartments list - list label',
    id: 'userApartmentsList.label',
  },
});
